<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="accounts"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title>Account</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="instructions">
        Account Details For:<br />
        Account Number: {{accountProfile.accountNumber}}<br />
        Dealership: {{dealership.dealershipName}}
    </ion-list-header>

    <ion-list class="ion-text-wrap">
        <ion-item data-test="profileItem" [disabled]=vb.disabled detail="true" id="profile" href="javascript:;" (click)="onShowPage('accountProfile')">
            <ion-label class="ion-text-wrap">
                <span class="line1">Account Profile</span><br />
                <span class="line2">Account detail information.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="ordersItem" [disabled]=vb.disabled detail="true" id="orders" href="javascript:;" (click)="onShowPage('orders')">
            <ion-label class="ion-text-wrap">
                <span class="line1">Orders</span><br />
                <span class="line2">View purchases.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="usersItem" [disabled]=vb.disabled detail="true" id="users" href="javascript:;" (click)="onShowPage('users')">
            <ion-label class="ion-text-wrap">
                <span class="line1">Users</span><br />
                <span class="line2">View all the users allowed to access this account.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="smsSentMessagesItem" [disabled]=vb.disabled detail="true" id="users" href="javascript:;" (click)="onShowPage('smsSentMessages')">
            <ion-label class="ion-text-wrap">
                <span class="line1">Sms Sent Messages</span><br />
                <span class="line2">View all the sms messages that have been sent.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="importExportItem" [disabled]=vb.disabled detail="true" id="users" href="javascript:;" (click)="onShowPage('importExport')">
            <ion-label class="ion-text-wrap">
                <span class="line1">Import and Export Collections</span><br />
                <span class="line2">Import and export firestore collections from/to csv.</span>
            </ion-label>
        </ion-item>

        @if (accountProfile.accountNumber === '00000-0000-00002') {
  <div>
            <ion-item data-test="resetCypressItem" [disabled]=vb.disabled detail="true" href="javascript:;" (click)="onShowPage('resetCypress')">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Reset Cypress Account</span><br />
                    <span class="line2">Delete the entire 00000-0000-00002 account and then recreate it.</span>
                </ion-label>
            </ion-item>
        </div>
}

    </ion-list>
</ion-content>